import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './Tour3D.css';

const Tour3D: React.FC = () => {
  const { projectName } = useParams<{ projectName: string }>();
  const [isLoading, setIsLoading] = useState(true);

  const tourData: Record<string, any> = {
    antares: {
      name: 'ANTARES II',
      subtitle: 'DE CAYALÁ',
      color: '#98281F',
      backgroundColor: '#FFFFFF',
      description: 'Recorrido virtual 360° del desarrollo residencial Antares II.',
      tourUrl: 'https://recorridoselmntgt.com/AntaresII/',
      title: 'AntaresII'
    },
    nogales: {
      name: 'NOGALES',
      subtitle: 'DE CAYALÁ',
      phase: 'FASE VII',
      color: '#7B8F47',
      backgroundColor: '#4A5D23',
      description: 'Explora los espacios verdes y la arquitectura sostenible de Nogales.',
      tourUrl: 'https://www.elmntgt.com/NogalesVII/',
      title: 'NogalesVII'
    },
    eonia: {
      name: 'EONIA',
      subtitle: 'DE CAYALÁ',
      color: '#4A90E2',
      backgroundColor: '#FFFFFF',
      description: 'Descubre la innovación y confort en este recorrido virtual.',
      tourUrl: 'https://recorridoselmntgt.com/Eonia/',
      title: 'Eonia'
    },
    azalea: {
      name: 'AZALEA',
      subtitle: 'DE CAYALÁ',
      color: '#801434',
      backgroundColor: '#8B1538',
      description: 'Experimenta el lujo y sofisticación de Azalea en 360°.',
      tourUrl: 'https://storage.googleapis.com/gbv/nogales/azalea/index.html',
      title: 'Azalea'
    },
    cayala: {
      name: 'CAYALÁ',
      subtitle: 'CIUDAD URBANISTA',
      color: '#8B4513',
      backgroundColor: '#FFFFFF',
      description: 'Recorre la primera ciudad urbanista de Guatemala.',
      tourUrl: 'https://www.elementvisualgt.com/LiriosIV/',
      title: 'LiriosIV'
    },
    altezza: {
      name: 'ALTEZZA',
      subtitle: 'DE CAYALÁ',
      color: '#2E8B57',
      backgroundColor: '#FFFFFF',
      description: 'Descubre las alturas de la elegancia en Altezza.',
      tourUrl: 'https://www.elementvisualgt.com/Altezza/',
      title: 'Altezza'
    }
  };

  const project = tourData[projectName || ''] || tourData['cayala'];

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
  };

  if (!project) {
    return (
      <div className="tour3d-viewer">
        <div className="tour-not-found">
          <h2>Tour 3D no encontrado</h2>
          <p>El proyecto "{projectName}" no tiene un tour virtual disponible.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tour3d-viewer">
      <div className="tour-header">
        <p className="tour-subtitle">EXPERIMENTA EL LUJO Y SOFISTICACIÓN EN 360°</p>
      </div>
      
      <div className="tour-container">
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>Cargando recorrido virtual...</p>
          </div>
        )}
        <iframe
          loading="lazy"
          src={project.tourUrl}
          title={project.title}
          className="tour-iframe"
          width="100%"
          height="100%"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          allow="accelerometer; magnetometer; gyroscope; autoplay; xr-spatial-tracking"
          allowFullScreen
          {...({
            mozallowfullscreen: "true",
            webkitallowfullscreen: "true"
          } as any)}
        />
      </div>
    </div>
  );
};

export default Tour3D;
